import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { GALLERY } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={GALLERY} id={id} />;
}

export const Route = createFileRoute("/_app/gallery/$id")({
  component: Edit,
});
